import React, { Fragment, useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import { configStyle, obtenerValorConfig } from '../services/configStyle'


const Header = (props) => {
    //process.env.PUBLIC_URL + '/images/wl/comp_logo.png'
    const [dataOtorgante, setDataOtorgante] = useState([]);
    const [pathname, setpathname] = useState('');
    const [hayCookies] = useState(navigator.cookieEnabled);

    useEffect(() => {
        let host = window.location.pathname;
        setpathname(host)
        if(hayCookies){
            let dataOtorganteLS = localStorage.getItem("dataOtorgante")
            if (dataOtorganteLS != null) {
                setDataOtorgante(JSON.parse(dataOtorganteLS))
                configStyle(JSON.parse(dataOtorganteLS))
            }
        }
        // //console.log(pathname);
        
    }, []);

    useEffect(() => {
        if (dataOtorgante) {
            configStyle(dataOtorgante)
        }
    }, [dataOtorgante])

    return (
        <Fragment>
            <div id="head_container">
                {
                    dataOtorgante ? 
                        <div>
                            <img id="imagenLogo" className="comp_logo animate__animated animate__slideInDown" src={(obtenerValorConfig(dataOtorgante, 'LOGO_OTORGANTE', "") != "") ? obtenerValorConfig(dataOtorgante, 'LOGO_OTORGANTE', process.env.PUBLIC_URL + '/images/wl/comp_logo.png') : process.env.PUBLIC_URL + '/images/wl/comp_logo.png'} alt="" />
                        </div>
                    :
                        ""
                }
            </div>
        </Fragment>
    );
}

export default Header;